import { useMemo } from "react";
import { useFirestoreDoc } from "./useFirestoreDoc";
import {
  AUTO_VOTE_MODES,
  autoVoteSettingsRef,
  isValidAutoVoteMode,
} from "../lib/data/availability";

// Phase 3: derive autoVoteMode with fallback to legacy autoVoteEnabled.
// Precedence:
//   1. Valid autoVoteMode string in the doc → use it verbatim.
//   2. Otherwise, legacy autoVoteEnabled === true → "submit" (preserves prior
//      behavior so users on Phase 2 default-on don't silently downgrade).
//   3. Otherwise → "off" (Tier 0 default for new users).
function deriveAutoVoteMode(data) {
  if (data && isValidAutoVoteMode(data.autoVoteMode)) {
    return data.autoVoteMode;
  }
  return data?.autoVoteEnabled === true ? "submit" : "off";
}

export function useAutoVoteSettings(uid) {
  const docRef = useMemo(() => autoVoteSettingsRef(uid || null), [uid]);
  const { data, loading, error } = useFirestoreDoc(docRef);

  return {
    autoVoteEnabled: data?.autoVoteEnabled === true,
    autoSubmitEnabled: data?.autoSubmitEnabled === true,
    autoVoteMode: deriveAutoVoteMode(data),
    settings: data || null,
    docExists: !!data,
    loading,
    error,
  };
}

export { AUTO_VOTE_MODES };
